interface ProjectAreaFields {
  area_atuacao?: string | null;
  area_canonica?: string | null;
}

/**
 * Área do projeto para exibição: a área canônica (preenchida no banco a partir
 * do cargo digitado, da vaga ou do freelancer) e, sem ela, o texto digitado.
 */
export function projectArea(project: ProjectAreaFields): string {
  return project.area_canonica?.trim() || project.area_atuacao?.trim() || "";
}
